/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AviFormsModule
 */

import {
    AbstractControl,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';

import inSubnet from 'insubnet';
import { isString } from 'angular';
import { getSubnetString } from 'ng/shared/utils/ip-prefix-parser.utils';
import { parseSubnetBaseIp } from 'ng/modules/avi-forms/utils/subnet-base-ip.parser.utils';

export const IP_RANGE_VALIDATOR_KEY = 'ipRangeInvalid';

/**
 * Validator function to check if ip or ip range are within subnet.
 */
export function validateIpInSubnet(subnetValue: string): ValidatorFn {
    /**
     * Returns null if IP is in subnet else,
     * returns an error object.
     */
    return (control: AbstractControl): ValidationErrors | null => {
        const { value: modelValue } = control;

        const errorObject = {
            [IP_RANGE_VALIDATOR_KEY]: modelValue,
        };

        if (!subnetValue) {
            return errorObject;
        }

        const subnetString = isString(subnetValue) ? subnetValue : getSubnetString(subnetValue);

        // Normalize subnet to base IP address (e.g., "100.66.108.10/24" -> "100.66.108.0/24")
        const subnet = parseSubnetBaseIp(subnetString) || subnetString;

        const isIpValid = modelValue.split(/[,-]/).every((ip: string) => {
            return inSubnet.Auto(ip.trim(), subnet);
        });

        return isIpValid ? null : errorObject;
    };
}
